import { render, staticRenderFns } from "./DetailsDiscountCoupon.html?vue&type=template&id=51256750&scoped=true&external"
import script from "./DetailsDiscountCoupon.js?vue&type=script&lang=js&external"
export * from "./DetailsDiscountCoupon.js?vue&type=script&lang=js&external"
import style0 from "./DetailsDiscountCoupon.scss?vue&type=style&index=0&id=51256750&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51256750",
  null
  
)

export default component.exports